function Stats({ stats }) {
  return (
    <div className={`stats${stats.total === 0 ? ' stats-empty' : ''}`}>
      <div className="stat sketch-box">
        <div className="k">{stats.total}</div>
        <div className="l">total applications</div>
        <div className="delta">
          {stats.total === 0 ? 'Start by adding or importing your first job' : 'Jobs you\'re tracking'}
        </div>
      </div>
      <div className="stat sketch-box">
        <div className="k">{stats.respRate}%</div>
        <div className="l">response rate</div>
        <div className="delta">
          {stats.total === 0 ? 'Change a job status to see your response rate' : `${stats.responded} of ${stats.total} heard back`}
        </div>
      </div>
      <div className="stat sketch-box">
        <div className="k">{stats.activeCount}</div>
        <div className="l">active applications</div>
        <div className="delta">
          {stats.total === 0 ? 'Your open applications will appear here' : 'Open jobs in progress'}
        </div>
      </div>
      <div className="stat sketch-box">
        <div className="k">
          {stats.avgSalary != null ? `$${stats.avgSalary.toLocaleString()}` : '—'}
        </div>
        <div className="l">average salary</div>
        <div className="delta">
          {stats.total === 0 ? 'Salary trends appear after you add pay info' : (stats.avgSalary == null ? 'Add salaries to see trends' : 'all jobs')}
        </div>
      </div>
    </div>
  );
}
